import { defineMessages } from 'react-intl';

import { EXTRACT_DOCUMENT_TYPES } from '@didaskill/domain/documents/constants';

export const extractDocumentTypesMessages = defineMessages<EXTRACT_DOCUMENT_TYPES>({
  [EXTRACT_DOCUMENT_TYPES.ACTIVITY_REPORT]: {
    defaultMessage: "Rapport d'activité",
  },
  [EXTRACT_DOCUMENT_TYPES.COMPLETION_DETAILS]: {
    defaultMessage: 'Détails de progression',
  },
  [EXTRACT_DOCUMENT_TYPES.COMPLETION_TRANSCRIPT]: {
    defaultMessage: 'Relevé de notes',
  },
  [EXTRACT_DOCUMENT_TYPES.ACHIEVEMENT_CERTIFICATE]: {
    defaultMessage: 'Certificat de réalisation',
  },
  [EXTRACT_DOCUMENT_TYPES.LIST_COMPLETION_DETAILS]: {
    defaultMessage: 'Détails de progression (liste)',
  },
});
